import React from 'react';
import { StarIcon } from 'lucide-react';
import type { Testimonial } from '../data/salesData';
interface TestimonialCardProps {
  testimonial: Testimonial;
  showLocation?: boolean;
}
function Stars() {
  return <div className="flex gap-0.5" aria-label="5 de 5 estrellas" data-id="element-200" data-mp="2kfx3vwi4amjo">
      {Array.from({
      length: 5
    }).map((_, i) => <StarIcon key={i} className="h-4 w-4 fill-[var(--lilac)] text-[var(--lilac)]" aria-hidden="true" data-id="element-201" data-mp="2p99g175m10vj" data-mpi={i} />)}
    </div>;
}
export function TestimonialCard({
  testimonial,
  showLocation = true
}: TestimonialCardProps) {
  return <figure className="flex h-full flex-col rounded-2xl border border-[var(--violet)]/40 bg-[#0d0819] p-6 transition-colors hover:border-[var(--lilac)]/70" data-id="element-202" data-mp="3460i5o6o4qou">
      <div className="mb-4 flex items-center gap-3" data-id="element-203" data-mp="3847wkcdntfwv">
        <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-[var(--violet)] text-sm font-bold text-white" aria-hidden="true" data-id="element-204" data-mp="19s9agu7wggw1">
          {testimonial.initials}
        </span>
        <div data-id="element-205" data-mp="hunqc2jbqpmj">
          <figcaption className="font-semibold text-[var(--cream)]" data-id="element-206" data-mp="d24dx8wdi0jb">
            {testimonial.name}
            {showLocation && <span className="font-normal text-white/50" data-id="element-207" data-mp="842v8p2v038d">
                {' '}
                · {testimonial.location}
              </span>}
          </figcaption>
          <Stars data-id="element-208" data-mp="10s8flaq03q7o" />
        </div>
      </div>
      <blockquote className="text-white/75" data-id="element-209" data-mp="10r6su8zmhfa4">“{testimonial.quote}”</blockquote>
    </figure>;
}